import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AmazonAutomation from "../pages/amazon-automation/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import Company from "../pages/company/page";
import Autopilot from "../pages/autopilot/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/amazon-automation",
    element: <AmazonAutomation />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/company",
    element: <Company />,
  },
  {
    path: "/autopilot",
    element: <Autopilot />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
